import React, { useState, useEffect } from "react";
import LoadingSpinner from "./loading";

const Navbar = () => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const user_id = localStorage.getItem("userId");
  //   const { user_id } = location.state || {};

  // useEffect(() => {
  //   const fetchUserData = async () => {
  //     try {
  //       const response = await fetch(
  //         process.env.REACT_APP_HOTE + `/recup-info-profil/${user_id}/`
  //       );
  //       if (!response.ok) throw new Error("Erreur réseau");
  //       const data = await response.json();
  //       setUser(data);
  //     } catch (error) {
  //       console.error(
  //         "Erreur lors de la récupération des données utilisateur:",
  //         error
  //       );
  //     }
  //   };

  //   fetchUserData();
  // }, [user_id]);

  // useEffect(() => {
  //   document.body.classList.add("mini-navbar"); // Ferme le menu par défaut
  // }, []);

  // Utilisation de `user` avec des vérifications
  const name = user?.nom ?? ''; // Utilisation d'une valeur par défaut si user est null
  const surname = user?.prenoms ?? ''; // Utilisation d'une valeur par défaut si user est null

  if (name && surname) {
    const Username = `${name} ${surname}`;
    localStorage.setItem('Username', Username);
  }

  const Username = localStorage.getItem('Username') || 'Utilisateur'; // Valeur par défaut

  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <div className="row border-bottom">
          <nav
            className="navbar navbar-static-top"
            role="navigation"
            style={{ marginBottom: 0 }}
          >
            <div className="navbar-header">
              <button
                className="m-3 btn btn-success"
                onClick={() => {
                  document.body.classList.toggle("mini-navbar");
                  if (window.SmoothlyMenu) {
                    window.SmoothlyMenu();
                  } else {
                    console.error("SmoothlyMenu is not defined on window");
                  }
                }}
              >
                <i className="fa fa-bars"></i>
              </button>
            </div>
            <ul className="nav navbar-top-links navbar-right">
              <li className="mr-2 d-flex align-items-center">
                {/* <i className="fa fa-bell" style={{ fontSize: "20px" }}></i> */}
                <span className="m-r-sm text-muted ml-2">
                  {/* Bienvenue, {Username} */}
                  Bienvenue, Gestionnaire
                </span>
              </li>
            </ul>
          </nav>
        </div>
      )}
    </>
  );
};

export default Navbar;
